import React from 'react';
var HeatmapWidget = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 100 100" },
        React.createElement("g", { fill: fill, fillRule: "evenodd" },
            React.createElement("rect", { width: "26", height: "26", opacity: ".5" }),
            React.createElement("rect", { width: "26", height: "26", x: "37", opacity: ".5" }),
            React.createElement("rect", { width: "26", height: "26", x: "74", opacity: ".3" }),
            React.createElement("rect", { width: "26", height: "26", y: "37", opacity: ".9" }),
            React.createElement("rect", { width: "26", height: "26", x: "37", y: "37", opacity: ".7" }),
            React.createElement("rect", { width: "26", height: "26", x: "74", y: "37", opacity: ".3" }),
            React.createElement("rect", { width: "26", height: "26", y: "74" }),
            React.createElement("rect", { width: "26", height: "26", x: "37", y: "74", opacity: ".9" }),
            React.createElement("rect", { width: "26", height: "26", x: "74", y: "74", opacity: ".7" }))));
};
export default HeatmapWidget;
